import { StepData } from "./sectionModels";

export class Application {
  id: string = "";
  applicationTypeId: string = "";
  accountId: string = "";
  templateVersion: string = "";
  applicationType: string = "";
  programId: string = "";
  uniqueApplicationCode: string = "";
  firstName: string = "";
  middleName: string = "";
  lastName: string = "";
  gender: string = "";
  role: string = "";
  email: string = "";
  streetAddressLine1: string = "";
  streetAddressLine2: string = "";
  locality: string = "";
  city: string = "";
  province: string = "";
  country: string = "";
  postalCode: string = "";
  verificationStatus: number = 1;
  phone: string = "";
  phoneExtension: string = "";
  dOB: string = "";
  mobile: string = "";
  submittedOn: string = "";
  assignedTo: string = "";
  internalStatus: number = 0;
  fullName: string = "";
  applicationData: ApplicationDataWrapper = new ApplicationDataWrapper();
  applicationDataJson: string = "";
  createdTime: string = "";
  updatedTime: string = "";
  createdBy: string = "";
  updatedBy: string = "";
  isActive: boolean = true;
  followUpInstruction: string = "";

  constructor(init?: Partial<Application> | Partial<ApplicationData>) {
    if (!init) return;

    if ("stepData" in init) {
      // This is nested ApplicationData being passed in
      this.applicationData.applicationData = new ApplicationData({
        lastStep: init.lastStep || "",
        inReviewMode: init.inReviewMode || false,
        stepData: init.stepData,
      });

      mapPersonalInformationToApplication(
        this,
        init?.stepData?.PersonalInformation
      );
      this.applicationType = this.applicationData.applicationType;
    } else if ("applicationData" in init) {
      // This is a full Application object being passed in
      Object.assign(this, init);
      mapPersonalInformationToApplication(
        this,
        init?.applicationData?.applicationData.stepData!.PersonalInformation
      );
      this.applicationType = this.applicationData.applicationType;
    }
  }
}

function mapPersonalInformationToApplication(ua: Application, pi: any) {
  if (!pi) return;
  ua.firstName = pi.givenName;
  ua.middleName = pi.middleName;
  ua.lastName = pi.surname;
  ua.fullName = pi.fullName;
  ua.gender = pi.gender;
  ua.email = pi.email;
  ua.phone = pi.phone;
  ua.mobile = pi.mobile;
  ua.streetAddressLine1 = pi.streetAddressLine1;
  ua.streetAddressLine2 = pi.streetAddressLine2;
  ua.locality = pi.locality;
  ua.province = pi.province;
  ua.country = pi.country;
  ua.postalCode = pi.postalCode;
}

export class ApplicationData {
  generation: number = 0;
  inReviewMode: boolean = false;
  lastStep: string = "";
  stepData: StepData = new StepData();

  constructor(init?: Partial<ApplicationData>) {
    Object.assign(this, init);
  }
}

export type BankAccount = {
  institutionNumber: string;
  transitNumber: string;
  accountNumber: string;
  bankName: string;
};

// Needed to match object structure, due to a double nested applicationData object
export class ApplicationDataWrapper {
  applicationType: string = "wildfire";
  lastStep: string = "Review";
  inReviewMode: boolean = false;
  applicationTypeId: string = "853775A8-EB1C-463C-8EB0-8A7BD0AA10E9";
  applicationData: ApplicationData = new ApplicationData();

  constructor(init?: Partial<ApplicationDataWrapper>) {
    Object.assign(this, init);
  }
}

export interface ApplicationPostRequest {
  application: string;
  applicationType: string;
  applicationId: string;
}
